import { db, type LocalUserContext } from './db'

export const storeUserContextPayload = async (payload: LocalUserContext) => {
  await db.userContext.add(payload)
}

export const getUserContextPayload = async () => {
  const payload = await db.userContext.toArray()
  return payload
}

export const deleteUserContextPayload = async () => {
  await db.userContext.clear()
}

export const deleteUserContextPayloadById = async (id: number) => {
  await db.userContext.delete(id)
}
